/**
 * @author Shalling(张小玲)
 * @email shalling@staritgp.com
 * @date 2020-04-29 19:20
 */
import React from 'react'

interface WithMyAssetsPropType {
  myAssets: (size?:number) => void
  assetsList:PagedData<MyServiceItem>
}
const context = React.createContext({} as WithMyAssetsPropType)
const { Provider, Consumer } = context

export default Component => function withMyAssets (props) {
  return (
    <Consumer>
      {
        ({ myAssets, assetsList }) => (
          <Component
            myAssets={myAssets}
            assetsList={assetsList}
            {...props}
          />
        )
      }
    </Consumer>
  )
}

export { Provider as MyAssetsProvider, context as MyAssetsContext, WithMyAssetsPropType }
